/*jshint -W040*/
(function () {
    'use strict';

    angular
        .module('app.region')
        .component('rmapRegionDisplay', {
            bindings: {
                model: '<',
                onStateRemoved: '&'
            },
            templateUrl: 'app/region/dashboard/region/regionDisplay/region.display.component.html',
            controller: regionDisplayController,
            controllerAs: 'vm'
        });

    function regionDisplayController() {
        var vm = this;

        vm.removeStates = removeStates;

        function removeStates(index) {
            vm.onStateRemoved({ index: index });
        }
    }

})();

